<div class="sidebar-main">
    <div class="sidebar-header">
        <div class="logo-icon">
            <!-- <img src="assets/images/common/logo.svg" alt=""> -->
             <img src="assets/images/common/logo.png" alt="">
        </div>
    </div>
    <div class="sidebar-content scrollbar-4">
        <div class="menu-wrapper">
            <div class="particular-menu" *ngFor="let menu of permittedMenus" [ngClass]="{active: isMenuActive(menu)}" (click)="goToMenu(menu.link)">
                <div class="menu-icon">
                    <app-icon [path]="isMenuActive(menu) ? menu.activeIcon : menu.icon"></app-icon>
                </div>
                <div class="menu-title">{{menu.title | translate}}</div>
            </div>
        </div>
    </div>
    <div class="sidebar-footer">
        <div class="left-section">
            <div class="profile-image">
                <img [src]="profilePic" alt="">
            </div>
            <div class="profile-detail">
                <div class="username">{{storageService.username}}</div>
                <!-- <div class="account-status" (click)="openConfirmPasswordDialog()">{{'changePassword' | translate}}</div> -->
            </div>
        </div>
        <div class="right-section">
            <div class="logout-icon" (click)="logout()">
                <img src="assets/images/common/logout-icon.svg" alt="">
            </div>
        </div>
    </div>
</div>